/*
* Pipeline Theme
*
* Use this file to add custom Javascript to Pipeline.  Keeping your custom
* Javascript in this fill will make it easier to update Pipeline. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*
*/


(function() {

  // Below are example event listeners.  They listen for theme events that Pipeline
  // fires in order to make it easier for you to add customizations.

  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.


  // ———————————————— NEW priceMap lookup ————————————————
// Find our JSON blob by looking for any <script> whose id starts with "VariantPriceStrings-"
const priceMapScript = document.querySelector('script[id^="VariantPriceStrings-"]');
let variantPriceStrings = {};
if (priceMapScript) {
  try {
    variantPriceStrings = JSON.parse(priceMapScript.textContent);
  } catch (e) {
    console.error('Failed to parse VariantPriceStrings JSON', e);
  }
} else {
  console.warn('VariantPriceStrings script tag not found');
}
// ————————————————————————————————————————————————————————————


  document.addEventListener('theme:variant:change', function(event) {
    const variant = event.detail.variant;
    if (!variant) return;

    const container = event.target.closest('[data-product-form-wrapper]');
    if (!container) return;

    const priceEl        = container.querySelector('[data-product-price]');
    const comparePriceEl = container.querySelector('[data-compare-price], .product__price--compare');
    const saveBox        = container.querySelector('[data-price-off]');

    // lookup our pre-formatted strings
    const formatted = variantPriceStrings[variant.id];
    if (!formatted) {
      console.warn('No formatted-price entry for variant', variant.id);
      return;
    }

    // 1) Main price + sale‐class
    if (priceEl) {
      priceEl.innerHTML = formatted.price;
      priceEl.classList.toggle('product__price--sale',
        variant.compare_at_price > variant.price
      );
    }

    // 2) Compare‐at price
    if (comparePriceEl) {
      if (variant.compare_at_price > variant.price) {
        comparePriceEl.innerHTML   = formatted.compare;
        comparePriceEl.style.display = 'inline';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    // 3) Save box
    if (saveBox) {
      if (variant.compare_at_price > variant.price) {
        saveBox.innerHTML     = `Save ${formatted.save}`;
        saveBox.style.display = 'inline-block';
      } else {
        saveBox.style.display = 'none';
      }
    }
  });


  document.addEventListener('theme:cart:change', function(event) {
    var cart = event.detail.cart;
    if (cart) {
      console.log('Cart ———————————— ↓');
      console.log(cart);
      // ... update an app or a custom shipping caluclator
    }
  });
  // Fired when page loads to update header values
  document.addEventListener('theme:cart:init', (e) => {
    console.log('theme:cart:init');
    console.log(e);
  });

  // Debounced scroll listeners.  Up and down only fire on direction changes
  // These events are useful for creating sticky elements and popups.
  document.addEventListener('theme:scroll', e => { console.log(e); });
  document.addEventListener('theme:scroll:up', e => { console.log(e); });
  document.addEventListener('theme:scroll:down', e => { console.log(e); });

  // Debounced resize listener to bundle changes that trigger document reflow
  document.addEventListener('theme:resize', e => { console.log(e); });

  // Locks and unlocks page scroll for modals and drawers
  // These are commented out because firing them will lock the page scroll
  // the lock event must set `detail` to the modal or drawer body so the 
  // scroll locking code knows what element should maintain scoll. 
  // document.dispatchEvent(new CustomEvent('theme:scroll:lock', {bubbles: true, detail: scrollableInnerElement}));
  // document.dispatchEvent(new CustomEvent('theme:scroll:unlock', {bubbles: true}));
  
  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.

  /* Javascript - Show cart drawer when product added to cart - added by TP*/
document.addEventListener('theme:cart:popdown', (e) => {
  const listener = (e) => {
    document.querySelector('[data-drawer="drawer-cart"]').dispatchEvent(
      new CustomEvent('theme:drawer:open', {
        bubbles: false,
      })
    );
    document.removeEventListener('theme:cart:change', listener);
  };
  document.addEventListener('theme:cart:change', listener);
});
/* end */
  
})();

/* Old code - TP, 2025-04-04
// Service points mapping (high price)
const servicePoints = {
  hotCold60: 100,
  hotCold30: 55,
  cryotherapy: 80,
  redLight30: 70,
  hyperbaric60: 170,
  hyperbaric90: 230,
  compression30: 50,
  compression60: 80
};
*/

/* Service points mapping (low price)
const servicePoints = {
  hotCold60: 90,
  hotCold30: 50,
  cryotherapy: 70,
  redLight30: 60,
  hyperbaric60: 150,
  hyperbaric90: 200,
  compression30: 40,
  compression60: 70
}; */

/* Old code - TP, 2025-04-04
// Function to calculate total points based on user input
function calculatePoints() {
  let totalPoints = 0;

  for (const service in servicePoints) {
    const serviceSessions = parseInt(document.getElementById(service).value) || 0;
    totalPoints += serviceSessions * servicePoints[service];
  }

  const totalPointsElement = document.getElementById('totalPoints');
  totalPointsElement.innerHTML = `Monthly Points Needed: <span style="color: #4BADAE">${totalPoints}</span>`;
}

// Function to update total points on input change
function updateTotalPoints() {
  calculatePoints();
}

// Attach the updateTotalPoints function to the "input" event of each service input field
for (const service in servicePoints) {
  const inputField = document.getElementById(service);
  inputField.addEventListener('input', updateTotalPoints);
}

// Initial calculation
calculatePoints();

// Calculator popup overlay
function showPopup(row, title, description, imageUrl) {
  const overlay = document.getElementById('overlay');
  const popupTitle = document.getElementById('popup-title');
  const popupDescription = document.getElementById('popup-description');
  const popupImage = document.getElementById('popupImage');

  popupTitle.innerText = title;
  popupDescription.innerText = description;
  popupImage.src = imageUrl;

  overlay.style.display = 'flex';
  row.classList.add('active'); // Mark the row as active
}

function closeOverlay() {
  const overlay = document.getElementById('overlay');
  overlay.style.display = 'none';
  const activeRow = document.querySelector('.row.active');
  if (activeRow) activeRow.classList.remove('active'); // Remove active class from row
}

// Close the popup if user clicks outside the popup content
window.addEventListener('click', function(event) {
  const overlay = document.getElementById('overlay');
  if (event.target == overlay) {
    closeOverlay();
  }
});
*/



/* Old code - TP, 2025-04-04
// Function to check if an element is in view
function isInView(el) {
  const rect = el.getBoundingClientRect();
  return rect.top < window.innerHeight && rect.bottom >= 0;
}

// Function to add the 'animate' class to elements in view
function animateElements() {
  const elements = document.querySelectorAll('.calccenter');
  elements.forEach(element => {
    if (isInView(element)) {
      element.classList.add('animate');
    }
  });
}

// Listen for scroll events and trigger the animation
window.addEventListener('scroll', () => {
  animateElements();
});

// Initially trigger the animation for elements in view on page load
animateElements();

// Remove placeholder zero on click
function removePlaceholder(element) {
  element.removeAttribute('placeholder');
}

// Add placeholder zero if user clicks out of input cell and no value entered
function addPlaceholder(element) {
  if (!element.value) {
    element.setAttribute('placeholder', '0');
  }
}
*/

/* Old code - TP, 2025-04-04
// card flip by Nancy
function flipCard(cardIndex, BackId) {
  console.log("card index " + cardIndex)
  var targetWowCard = 'wowcard' + cardIndex;
  
  // Turn off visibility of both target back content 
  document.getElementById(targetWowCard + '-back1').style.visibility = "hidden";
  document.getElementById(targetWowCard + '-back2').style.visibility = "hidden";

  var back3Element = document.getElementById(targetWowCard + '-back3');
 
  if (back3Element){
    back3Element.style.visibility = "hidden";
  }
  
  // Turn on visibility of target back content 
  const backContent = document.getElementById(targetWowCard + '-' + BackId)
  backContent.style.visibility = "visible"

  // Flip card 
  const wowcard = document.getElementById(targetWowCard);
  wowcard.classList.toggle('flipped');
}

function flipBack(cardIndex) {
  console.log("flipBack" + cardIndex)
  // Flip card back to front
  const wowcard = document.getElementById('wowcard' + cardIndex);
  wowcard.classList.remove('flipped');
}
*/

/* Fullbody parallax 
const background = document.querySelector('.background-fullbody'); 


document.addEventListener('scroll', () => {
  const scrollValue = window.scrollY;
  background.style.transform = `translateY(${scrollValue * 0.2}px)`; // Adjust the multiplier to control the parallax effect

  
});*/


/* Old code - TP, 2025-04-04

// Function to open Vagaro 'My account' in a new tab
    // Add an event listener to the link
    document.querySelector('a[href="https://www.vagaro.com/myaccount/profile"]').addEventListener('click', function(event) {
      event.preventDefault(); // Prevent the default behavior of following the link
      window.open(this.href, '_blank'); // Open the link in a new tab
    });


// Scroll and Zoom image function
document.addEventListener('DOMContentLoaded', function() {

// Member benefits
const image1 = document.querySelector('.image1');
const image2 = document.querySelector('.image2');
const image3 = document.querySelector('.image3');
const image4 = document.querySelector('.image4');
const image5 = document.querySelector('.image5');
const contract = document.querySelector('.contract');
const contract2 = document.querySelector('.contract2');

document.addEventListener('scroll', () => {
  const moveAmount = window.innerHeight - contract.getBoundingClientRect().top;
  const moveAmount2 = window.innerHeight - contract2.getBoundingClientRect().top;

  // Zoom effect for image1
  const zoomLevel = 1 + (moveAmount / window.innerHeight) * 0.2;
  const zoomLevel2 = 1 + (moveAmount2 / window.innerHeight) * 0.2;
  image1.style.transform = `scale(${zoomLevel})`;
  image3.style.transform = `scale(${zoomLevel})`;
  image4.style.transform = `scale(${zoomLevel2})`;

  // Vertical position adjustment for image2
  const translateY = Math.min(moveAmount, window.innerHeight) / 15;
  const translateY2 = Math.min(moveAmount2, window.innerHeight) / 18;
  image2.style.transform = `translateY(${-translateY}px)`;
  image5.style.transform = `translateY(${-translateY2}px)`;
  });
});
*/


// Comparison Table Optimizations
  document.addEventListener("DOMContentLoaded",function(){try{var t=document.querySelector(".comparisonTableContainer"),e=document.querySelector("header"),l=e&&"fixed"==getComputedStyle(e,null).position&&e.getBoundingClientRect().top>=0?e.offsetHeight:"0";if(t){var o=t.querySelector(".comp-table__emptyRow"),i=t.querySelectorAll(".comp-table__tableBodyRow .comp-table__tableData"),n=t.querySelector("tbody"),r=t.querySelector("thead"),s=t.querySelectorAll(".comp-table__columnHeader"),c=r.querySelector(".comp-table__columnHeaders");r.querySelectorAll(".comp-table__columnHeader:not(.comp-table__emptyCell)");var a=t.querySelector(".horizontal-scroller"),d=a.querySelector(".horizontal-scroller-content"),u=t.querySelectorAll(".comp-table__columnGroupSection");t.insertAdjacentHTML("afterbegin",'<div class="comp-table__columnGroupSection comp-table__columnGroupSectionDesktop comp-table__tableRow first comp-table__stickyRowGroupPH" style="font-weight: bold;"><div class="comp-table__tableData"><span></span></div></div>');var f=document.querySelector(".comp-table__stickyRowGroupPH")}function m(e,o){f.classList.add("stickyHeader"),f.style.top=o.height+l+"px",f.querySelector(".comp-table__tableData").style.minWidth=t.offsetWidth+"px",f.querySelector(".comp-table__tableData").style.maxWidth=t.offsetWidth+"px",f.querySelector("span").innerHTML=e.querySelector("span").innerHTML}function p(){var e,i,s,p,L=t.getBoundingClientRect(),b=r.getBoundingClientRect(),v=n.getBoundingClientRect();if(c.getBoundingClientRect(),a.style.left=L.left+"px",a.style.width=L.width+"px",d.style.width=t.scrollWidth+"px",L.top<=0+l&&L.height-50>window.innerHeight?(e=L,i=b,s=v,r.classList.add("stickyHeader"),r.style.top=l+"px",y(t),g(e),p=parseFloat(getComputedStyle(n).transform.substring(getComputedStyle(n).transform.indexOf("(")+1,getComputedStyle(n).transform.lastIndexOf(")")).split(",")[5]),(0===p||"none"==getComputedStyle(n).transform)&&(o.style.height=r.offsetHeight+"px")):v.top>=0+l&&h(),L.bottom<=window.innerHeight||L.top+l>window.innerHeight?a.style.visibility="hidden":L.top+l<=window.innerHeight&&t.clientWidth<t.scrollWidth&&(a.style.visibility="visible"),L.bottom<=b.bottom&&!Array.from(r.classList).includes("atBottom")?r.classList.add("atBottom"):b.top>=0+l&&r.classList.remove("atBottom"),(!Array.from(r.classList).includes("stickyHeader")||Array.from(r.classList).includes("atBottom"))&&(f.classList.remove("stickyHeader"),f.querySelector("span").innerHTML=""),!Array.from(r.classList).includes("atBottom"))for(let H=0;H<u.length;H++){var S=u[H];S.getBoundingClientRect().top<=b.bottom&&Array.from(r.classList).includes("stickyHeader")&&m(S,b)}}function y(t){r.scrollLeft=t.scrollLeft}function g(t){r.style.width=t.width+"px",r.style.left=t.left+"px";for(let e=0;e<s.length;e++)i[e].getBoundingClientRect(),Array.from(r.classList).includes("stickyHeader")?s[e].style.minWidth=getComputedStyle(i[e]).width:s[e].style.minWidth="initial"}function h(){r.classList.remove("stickyHeader"),r.style.top="0x",o.style.height="initial"}window.addEventListener("scroll",function(){l=e&&"fixed"==getComputedStyle(e,null).position&&e.getBoundingClientRect().top>=0?e.offsetHeight:"0",t&&p()});var L=window.innerWidth;if(window.addEventListener("resize",function(e){if(t){h(),p();var l=t.getBoundingClientRect();e.target.innerWidth<L&&(g(l),L=window.innerWidth)}}),t&&t.addEventListener("scroll",function(t){Array.from(r.classList).includes("stickyHeader")&&!Array.from(r.classList).includes("atBottom")&&y(t.target),a.scrollLeft=t.target.scrollLeft}),t&&a.addEventListener("scroll",function(e){Array.from(r.classList).includes("stickyHeader")&&!Array.from(r.classList).includes("atBottom")&&y(e.target),t.scrollLeft=e.target.scrollLeft}),t&&r.addEventListener("scroll",function(e){a.scrollLeft=e.target.scrollLeft,t.scrollLeft=e.target.scrollLeft}),t){var b=t.getBoundingClientRect();g(b),p()}var v=document.querySelector(".comp-table_pricingToggle");if(v){var H=v.querySelectorAll("input[name='annual_monthly']");for(let S=0;S<H.length;S++)H[S].addEventListener("change",function(t){for(let e=0;e<s.length;e++){var l=s[e].querySelector(".comp-table__price");l&&(l.innerHTML=l.getAttribute(t.target.value))}})}}catch(q){console.log(q)}});
       
/* Old code, TP - 2025/04/04
//Price Table
//const tbody = document.querySelector("tbody");
const tbody = document.querySelector("#priceTable tbody");

// Create table rows dynamically
for (let i = 0; i < 9; i++) {
  const row = document.createElement("tr");
  for (let j = 0; j < 5; j++) {
    const cell = document.createElement("td");
    cell.textContent = `Row ${i + 1}, Col ${j + 1}`;
    row.appendChild(cell);
  }
  tbody.appendChild(row);
}
*/


//Drop-down for Memberships
function toggleDropIn(element) {
    let content = element.nextElementSibling;
    content.classList.toggle('active');
}

function togglePriorityBooking(element) {
    var content = element.nextElementSibling;
    content.classList.toggle("active");
}



document.addEventListener('DOMContentLoaded', function () {
  // Open correct modal on "Join" button click
  document.querySelectorAll('.open-membership-modal').forEach(button => {
    button.addEventListener('click', () => {
      const membership = button.dataset.membership.toLowerCase();
      const modal = document.getElementById(`${membership}Modal`);
      if (modal) {
        modal.classList.remove('hidden');
      }
    });
  });

  // Close modal on close button click
  document.querySelectorAll('.modal .close-button').forEach(closeBtn => {
    closeBtn.addEventListener('click', () => {
      const modal = closeBtn.closest('.modal');
      if (modal) {
        modal.classList.add('hidden');
        const membership = modal.id.replace('Modal', '').toLowerCase();
        document.getElementById(`${membership}FormContainer`).classList.remove('hidden');
        document.getElementById(`${membership}Confirmation`).classList.add('hidden');
        const form = document.getElementById(`${membership}MembershipForm`);
        if (form) form.reset();
      }
    });
  });

  // Attach submission handler to all 3 membership forms
  document.querySelectorAll('.membershipForm').forEach(form => {
    form.addEventListener('submit', handleSubmit);
  });
});

function handleSubmit(event) {
  event.preventDefault();

  const form = event.target;
  const membership = form.dataset.membership; // e.g., "Starter", "Focused", "Elite"
  const formId = membership.toLowerCase();

  const formData = new FormData(form);
  const jsonData = {};

  formData.forEach((value, key) => {
    jsonData[key] = value;
  });

  console.log(`Submitting ${membership} membership:`, jsonData);

  const SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbxg7t8WnQX7R80Ak-R2HiPXOb3EF6jFe0pfAT5c4GZFbOgw2KWgA5Ak9IgDa_copr0glA/exec';

  // Hidden iframe approach
  const iframeName = 'hidden-iframe-' + Math.floor(Math.random() * 1000);
  const iframe = document.createElement('iframe');
  iframe.style.display = 'none';
  iframe.name = iframeName;
  document.body.appendChild(iframe);

  const hiddenForm = document.createElement('form');
  hiddenForm.method = 'POST';
  hiddenForm.action = SCRIPT_URL;
  hiddenForm.target = iframeName;

  const input = document.createElement('input');
  input.type = 'hidden';
  input.name = 'payload';
  input.value = JSON.stringify(jsonData);
  hiddenForm.appendChild(input);

  // Show confirmation and hide form
  document.getElementById(`${formId}FormContainer`).style.display = 'none';
  document.getElementById(`${formId}Confirmation`).style.display = 'block';

  // Open Jane login in new tab
  const newTab = window.open('https://regen-recovery.janeapp.com/login', '_blank', 'noopener,noreferrer');
  if (newTab) newTab.blur();
  window.focus();

  document.body.appendChild(hiddenForm);
  hiddenForm.submit();

  // Cleanup
  setTimeout(() => {
    document.body.removeChild(hiddenForm);
    document.body.removeChild(iframe);
  }, 3000);
}








document.addEventListener('DOMContentLoaded', function () {
    const services = [
        { name: "Sauna / Cold Plunge (2 people)", dropInPrice: 89, id: "sauna2" },
        { name: "Sauna / Cold Plunge 30", dropInPrice: 49, id: "sauna30" },
        { name: "Sauna / Cold Plunge (4 people)", dropInPrice: 109, id: "sauna4" },
        { name: "Red Light", dropInPrice: 69, id: "red" },
        { name: "Hyperbaric 60", dropInPrice: 169, id: "hyper60" },
        { name: "Hyperbaric 90", dropInPrice: 229, id: "hyper90" },
        { name: "DEXA", dropInPrice: 199, id: "dexa" },
        { name: "VO2 Max", dropInPrice: 199, id: "vo2" },
        { name: "Assisted Stretch", dropInPrice: 129, id: "stretch" },
        { name: "Compression", dropInPrice: 39, id: "compression" }
    ];

    const memberships = {
        Starter: { discount: 0.20, color: '#3B82F6', position: 0 },
        Focused: { discount: 0.25, color: '#6366F1', position: 33.33 },
        Elite: { discount: 0.30, color: '#8B5CF6', position: 66.66 }
    };

    const membershipOptions = document.querySelectorAll('.membership-option');
    const sliderThumb = document.getElementById('sliderThumb');
    const discountText = document.querySelector('.discount-text');
    let activeMembership = 'Starter';

    function updateMembershipUI(membership) {
        membershipOptions.forEach(option => {
            option.classList.toggle('active', option.dataset.membership === membership);
        });

        const membershipData = memberships[membership];
        if (sliderThumb) {
            sliderThumb.style.backgroundColor = membershipData.color;
            sliderThumb.style.left = membershipData.position + '%';
        }
        if (discountText) {
            discountText.textContent = (membershipData.discount * 100) + '% Off';
        }

        updatePrices(membership);
    }

    function updatePrices(membership) {
        const discount = memberships[membership].discount;

        services.forEach(service => {
            const memberPriceEl = document.getElementById(`${service.id}Price`);
            const savingsEl = document.getElementById(`${service.id}Savings`);

            if (memberPriceEl && savingsEl) {
                const memberPrice = (service.dropInPrice * (1 - discount)).toFixed(0);
                const savings = (service.dropInPrice - memberPrice).toFixed(0);

                memberPriceEl.textContent = `$${memberPrice}`;
                savingsEl.textContent = `$${savings}`;
            }
        });
    }

    membershipOptions.forEach(option => {
        option.addEventListener('click', function () {
            const newMembership = this.dataset.membership;
            if (newMembership !== activeMembership) {
                activeMembership = newMembership;
                updateMembershipUI(activeMembership);
            }
        });
    });

    updateMembershipUI('Starter');
});




// Parallax effect with reduced scroll speed
window.addEventListener('scroll', function () {
    const section = document.querySelector('.custom-parallax-section');
    const image = document.querySelector('.parallax-image');

    if (!section || !image) return;

    // Get scroll position
    const scrollY = window.scrollY;
    const sectionOffsetTop = section.offsetTop;
    const sectionHeight = section.offsetHeight;

    // Only apply parallax effect when the section is in the viewport
    if (
      scrollY + window.innerHeight > sectionOffsetTop &&
      scrollY < sectionOffsetTop + sectionHeight
    ) {
      // Calculate the amount of scroll relative to the section
      const relativeScroll = scrollY - sectionOffsetTop;

      // Set the parallax speed (lower values = slower movement)
      const parallaxSpeed = 0.32; // Adjust this for effect speed
      const newBackgroundPosition = `center ${relativeScroll * parallaxSpeed}px`;

      // Update background-position to create the parallax effect
      image.style.backgroundPosition = newBackgroundPosition;
    }
  });



// Parallax PNG with dynamic scaling + scale clamping + proper initial load for both images
function updateParallax() {
  const scrollY = window.scrollY;

  // Left-aligned PNG
  const parallaxWrapperLeft = document.querySelector(".parallax-png-wrapper");
  const parallaxImageLeft = document.querySelector(".parallax-png");

  // Right-aligned PNGs
  const parallaxWrapperRight = document.querySelector(".parallax-png-wrapper-right");
  const parallaxImageRight = document.querySelector(".parallax-png-right");
  const parallaxWrapperRight2 = document.querySelector(".parallax-png-wrapper-right2");
  const parallaxImageRight2 = document.querySelector(".parallax-png-right2");

  const maxOffset = 500;
  const offset = scrollY * 0.15;
  const reverseOffset = -scrollY * 0.10;

  const baseScale = 0.9;
  const baselineWidth = 1920;
  const rawScale = baseScale * (window.innerWidth / baselineWidth);
  const scale = Math.min(0.6, Math.max(0.4, rawScale));

  // Left Image
  if (parallaxImageLeft && parallaxWrapperLeft) {
    parallaxImageLeft.style.transform = `translateY(${offset}px) scale(${scale})`;
    parallaxImageLeft.style.visibility = "visible";
    parallaxWrapperLeft.style.position = "absolute";
    parallaxWrapperLeft.style.top = "0px";
  }

  // Right Image
  if (parallaxImageRight && parallaxWrapperRight) {
    parallaxImageRight.style.transform = `translateY(${reverseOffset}px) scale(${scale})`;
    parallaxImageRight.style.visibility = "visible";
    parallaxWrapperRight.style.position = "absolute";
    parallaxWrapperRight.style.top = "0px";
  }

  // Right2 Image (new one you added)
  if (parallaxImageRight2 && parallaxWrapperRight2) {
    parallaxImageRight2.style.transform = `translateY(${reverseOffset}px) scale(${scale})`;
    parallaxImageRight2.style.visibility = "visible";
    parallaxWrapperRight2.style.position = "absolute";
    parallaxWrapperRight2.style.top = "0px";
  }
}


// Run once immediately
document.addEventListener("DOMContentLoaded", () => {
  updateParallax();
});

// Run on scroll and resize
document.addEventListener("scroll", updateParallax);
window.addEventListener("resize", updateParallax);



// Parallax logic for centered and enlarged PNG only
function updateParallaxCenter() {
  const scrollY = window.scrollY;

  const parallaxWrapperCenter = document.querySelector(".parallax-png-wrapper-center");
  const parallaxImageCenter = document.querySelector(".parallax-png-center");

  if (!parallaxWrapperCenter || !parallaxImageCenter) return;

  // Scroll offset for subtle movement
  const offsetCenter = scrollY * 0.08;

  // Responsive scaling with clamping
  const baseScale = 0.35;
  const baselineWidth = 1920;
  const rawScale = baseScale * (window.innerWidth / baselineWidth);
  const scale = Math.min(0.6, Math.max(0.4, rawScale)); // Clamp between 0.4 and 0.6

  // Apply transform to center image (scale doubled)
  parallaxImageCenter.style.transform = `translateY(${offsetCenter}px) scale(${2 * scale})`;
  parallaxImageCenter.style.visibility = "visible";

  // Ensure wrapper stays centered and offset down 50px
  parallaxWrapperCenter.style.position = "absolute";
  parallaxWrapperCenter.style.top = "50%";
  parallaxWrapperCenter.style.left = "50%";
  parallaxWrapperCenter.style.transform = `translate(-50%, -32px)`;
}

// Attach center update alongside main listeners
document.addEventListener("DOMContentLoaded", updateParallaxCenter);
document.addEventListener("scroll", updateParallaxCenter);
window.addEventListener("resize", updateParallaxCenter);







// ==================== Membership Recommendation Calculator ===================
document.addEventListener("DOMContentLoaded", function () {
  const servicePrices = {
    "Hot/Cold 2 people": 89,
    "Hot/Cold 30": 49,
    "Hot/Cold 4 people": 109,
    "Red Light": 69,
    "Hyperbaric 60": 169,
    "Hyperbaric 90": 229,
    "DEXA": 199,
    "VO2 Max": 199,
    "Assisted Stretch": 129,
    "Compression": 39,
  };

  const memberships = [
    { name: "Starter", monthlyFee: 89, discount: 0.2 },
    { name: "Focused", monthlyFee: 199, discount: 0.25 },
    { name: "Elite", monthlyFee: 499, discount: 0.3 },
  ];

  const sessionInputs = document.querySelectorAll(".monthly-sessions");
  const plusButtons = document.querySelectorAll(".plus-btn");
  const minusButtons = document.querySelectorAll(".minus-btn");

  const totalNoMembershipEl = document.getElementById("totalNoMembership");
  const recommendedMembershipEl = document.getElementById("recommendedMembership");
  const youSaveEl = document.getElementById("youSave");
  const totalWithMembershipEl = document.getElementById("totalWithMembership");

  function formatInputValue(value) {
    const num = parseFloat(value);
    return isNaN(num) ? "0" : (num % 1 === 0 ? String(parseInt(num)) : String(num));
  }

  function calculateTotals() {
    let totalWithoutMembership = 0;

    document.querySelectorAll("tr[data-service]").forEach((row) => {
      const service = row.getAttribute("data-service");
      const input = row.querySelector(".monthly-sessions");
      const sessions = parseFloat(input.value) || 0;
      const price = servicePrices[service] || 0;
      totalWithoutMembership += sessions * price;
    });

    totalNoMembershipEl.textContent = `$${totalWithoutMembership.toFixed(2)}`;

    const viableOptions = memberships
      .map((membership) => {
        const totalWithMembership = totalWithoutMembership * (1 - membership.discount);
        return {
          ...membership,
          totalWithMembership,
        };
      })
      .filter((option) => totalWithoutMembership >= option.monthlyFee)
      .sort((a, b) => b.monthlyFee - a.monthlyFee);

    if (viableOptions.length > 0) {
      const best = viableOptions[0];
      recommendedMembershipEl.textContent = best.name;
      const savings = totalWithoutMembership * best.discount;
      const finalWithMembership = totalWithoutMembership - savings;

      youSaveEl.textContent = `$${savings.toFixed(2)}`;
      totalWithMembershipEl.textContent = `$${finalWithMembership.toFixed(2)}`;

      totalNoMembershipEl.classList.add("strikethrough");
      totalNoMembershipEl.style.color = "#999";
    } else {
      recommendedMembershipEl.textContent = " - - ";
      youSaveEl.textContent = "$0.00";
      totalWithMembershipEl.textContent = "$0.00";

      totalNoMembershipEl.classList.remove("strikethrough");
      totalNoMembershipEl.style.color = "white";
    }
  }

  plusButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const input = this.parentElement.querySelector(".monthly-sessions");
      const current = parseFloat(input.value) || 0;
      const newVal = current + 1;
      input.value = formatInputValue(newVal);
      calculateTotals();
    });
  });

  minusButtons.forEach((btn) => {
    btn.addEventListener("click", function () {
      const input = this.parentElement.querySelector(".monthly-sessions");
      const current = parseFloat(input.value) || 0;
      const newVal = Math.max(0, current - 1);
      input.value = formatInputValue(newVal);
      calculateTotals();
    });
  });

  // Only reformat (hide decimals) when user leaves the input
  sessionInputs.forEach((input) => {
    input.addEventListener("input", () => {
      calculateTotals();
    });

    input.addEventListener("blur", () => {
      input.value = formatInputValue(input.value);
    });
  });

  calculateTotals();
});






/* Javascript - Show cart drawer when product added to cart - added by TP
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('drawer-cart');

  if (!drawer) {
    console.warn('Cart drawer not found.');
    return;
  }

  // ✅ Open and refresh cart drawer content after cart change
  document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('drawer-cart');

  if (!drawer) return;

  // Only open drawer on cart updates
  document.addEventListener('theme:cart:change', function (event) {
    console.log('[Cart] theme:cart:change fired');

    drawer.classList.add('open');
    document.body.classList.add('drawer-open');

    // Load actual cart data into placeholders
    fetch(window.Shopify.routes.root + 'cart?section_id=cart-drawer')
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const newHTML = parser.parseFromString(html, 'text/html');
        const updatedDrawer = newHTML.querySelector('#drawer-cart');

        if (updatedDrawer) {
          drawer.innerHTML = updatedDrawer.innerHTML;
          console.log('[Cart] Drawer content updated');
        }
      })
      .catch(err => {
        console.error('[Cart] Failed to fetch cart drawer content', err);
      });
  });

  // Close logic
  document.addEventListener('click', function (e) {
    if (
      e.target.matches('[data-drawer-toggle="drawer-cart"]') ||
      e.target.closest('.drawer__underlay')
    ) {
      drawer.classList.remove('open');
      document.body.classList.remove('drawer-open');
    }
  });
});
*/



/* Finalized Cart Drawer Logic */
document.addEventListener('DOMContentLoaded', function () {
  const drawer = document.getElementById('drawer-cart');
  if (!drawer) {
    console.warn('[Cart] Drawer not found on page.');
    return;
  }

  // Skip the initial cart:change on page load
  let initialLoad = true;

  document.addEventListener('theme:cart:change', function (event) {
    const cart = event.detail && event.detail.cart;
    if (!cart) return;

    if (initialLoad) {
      initialLoad = false;
      return;
    }

    // Only open on actual "Add to Cart" (items_added array)
    if (Array.isArray(cart.items_added) && cart.items_added.length > 0) {
      drawer.classList.add('open');
      document.body.classList.add('drawer-open');
      console.log('[Regen Cart] Opened drawer after Add to Cart');
    }
  });

  // Keep the drawer open on subsequent AJAX updates (remove/quantity)
  const parent = drawer.parentElement;
  if (parent) {
    const observer = new MutationObserver(() => {
      if (!drawer.classList.contains('open')) {
        drawer.classList.add('open');
        document.body.classList.add('drawer-open');
        console.log('[Regen Cart] Kept drawer open after update');
      }
    });
    observer.observe(parent, { childList: true });
  }
});




/* Hero (video section) Add-to-Cart -> AJAX + refresh cart drawer + open */
document.addEventListener('DOMContentLoaded', function () {
  async function refreshCartDrawerHTML() {
    // Pull the latest cart drawer section HTML from Shopify
    const res = await fetch('/cart?section_id=cart-drawer', {
      headers: { 'Accept': 'text/html' }
    });
    const html = await res.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');

    // We only replace the INNER drawer content so we don't break #drawer-cart references
    const newContent = doc.querySelector('#drawer-cart .drawer__content');
    const currentContent = document.querySelector('#drawer-cart .drawer__content');

    if (newContent && currentContent) {
      currentContent.innerHTML = newContent.innerHTML;
      return true;
    }

    console.warn('[Hero ATC] Could not find drawer content to replace.');
    return false;
  }

  function openCartDrawer() {
    const drawer = document.getElementById('drawer-cart');
    if (!drawer) return;

    // Keep your existing behavior consistent
    drawer.classList.add('open');
    document.body.classList.add('drawer-open');

    // If Pipeline is listening for this, it helps with scroll-lock + focus
    try {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
    } catch (e) {}
  }

  function bindHeroATC(form) {
    if (!form || form.dataset.heroAtcBound === 'true') return;
    form.dataset.heroAtcBound = 'true';

    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const btn = form.querySelector('[data-add-to-cart], button[type="submit"]');
      if (btn) btn.setAttribute('aria-busy', 'true');

      try {
        const formData = new FormData(form);

        // 1) Add item via AJAX (prevents redirect to /cart)
        const addRes = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: formData
        });

        if (!addRes.ok) throw new Error('Add to cart failed');
        const addedItem = await addRes.json();

        // 2) Fetch latest cart JSON so your existing listeners stay happy
        const cartRes = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
        const cart = await cartRes.json();
        cart.items_added = [addedItem]; // IMPORTANT: matches what your drawer-open logic expects

        // 3) Trigger theme cart change events (does NOT refresh HTML by itself)
        document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart } }));
        document.dispatchEvent(new CustomEvent('theme:cart:popdown', { detail: { cart } }));

        // 4) Refresh drawer HTML so it isn't blank / stale
        await refreshCartDrawerHTML();

        // 5) Open drawer (now populated)
        openCartDrawer();

      } catch (err) {
        console.error('[Hero ATC]', err);
        // Fallback: do normal submit if something fails
        form.submit();
      } finally {
        if (btn) btn.setAttribute('aria-busy', 'false');
      }
    });
  }

  // Bind existing hero forms
  document.querySelectorAll('form[data-hero-atc-form]').forEach(bindHeroATC);

  // Bind forms added later (theme editor / section re-render)
  const obs = new MutationObserver(() => {
    document.querySelectorAll('form[data-hero-atc-form]').forEach(bindHeroATC);
  });
  obs.observe(document.body, { childList: true, subtree: true });
});
/* End Hero ATC */


(() => {
  let heroClickedRecently = false;
  let heroTimer = null;

  // 1) Mark “hero ATC was used”
  document.addEventListener("click", (e) => {
    const heroBtn = e.target.closest("[data-hero-atc-trigger]");
    if (!heroBtn) return;

    heroClickedRecently = true;
    clearTimeout(heroTimer);

    // window where the drawer will open right after click
    heroTimer = setTimeout(() => {
      heroClickedRecently = false;
    }, 2500);
  });

  // 2) When drawer opens/closes, add/remove the hero-only class
  function init() {
    const drawer = document.getElementById("drawer-cart");
    if (!drawer) return;

    const isOpen = () =>
      drawer.classList.contains("drawer--visible") ||
      drawer.classList.contains("open") ||
      drawer.classList.contains("is-open") ||
      drawer.getAttribute("aria-hidden") === "false";

    let wasOpen = isOpen();

    const mo = new MutationObserver(() => {
      const openNow = isOpen();

      // Drawer just opened → if hero click caused it, apply fix
      if (!wasOpen && openNow && heroClickedRecently) {
        drawer.classList.add("hero-drawer-bg-fix");
      }

      // Drawer just closed → always remove fix (so other ATCs are untouched)
      if (wasOpen && !openNow) {
        // keep it briefly to cover close animation
        setTimeout(() => drawer.classList.remove("hero-drawer-bg-fix"), 1200);
      }

      wasOpen = openNow;
    });

    mo.observe(drawer, { attributes: true, attributeFilter: ["class", "aria-hidden"] });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();





/* Membership Email Sign Up Form */
  function handleMembershipSignup(event) {
    event.preventDefault();

    const form = event.target;
    const data = new FormData(form);

    fetch("https://script.google.com/macros/s/AKfycbxg7t8WnQX7R80Ak-R2HiPXOb3EF6jFe0pfAT5c4GZFbOgw2KWgA5Ak9IgDa_copr0glA/exec", {
      method: "POST",
      body: data
    })
    .then(response => response.text())
    .then(result => {
  document.getElementById("membershipSignupForm").style.display = "none";
  document.getElementById("signupSuccessMessage").style.display = "block";
  document.getElementById("membershipMessage").style.display = "none"; // Hides the paragraph
})
    .catch(error => {
      console.error("Error submitting form:", error);
      alert("There was a problem submitting the form. Please try again.");
    });
  }



/* Open Jane App "My Account/Login" in new tab. */
document.addEventListener('DOMContentLoaded', () => {
  const menuLinks = document.querySelectorAll('a[href="https://regen-recovery.janeapp.com/login"]');
  menuLinks.forEach(link => link.setAttribute('target', '_blank'));
});



/* Ticker horizontal scroll speed */
function announcementTicker() {
  return {
    stopClone: true,
    init() {
      const ticker = this.$el.querySelector('[data-ticker-text]');
      const container = this.$el;
      const distance = ticker.scrollWidth;
      const speed = 50; // pixels per second – tweak this for slower/faster

      const duration = distance / speed;

      ticker.style.setProperty('--animation-duration', `${duration}s`);
      ticker.classList.add('ticker--animated');
    }
  };
}



/* Always open any janeapp.booking link in a new tab */
document.addEventListener('DOMContentLoaded', function () {
  // Select every <a> whose href begins with your JaneApp domain
  const janeLinks = document.querySelectorAll('a[href^="https://regen-recovery.janeapp.com/"]');
  janeLinks.forEach(function(link) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  });
});


/*Hide Shop Pay installments option */
document.addEventListener("DOMContentLoaded", function () {
  // Wait for the DOM to be ready
  const observer = new MutationObserver(() => {
    const shopPayEl = document.querySelector("shopify-payment-terms");
    if (shopPayEl) {
      shopPayEl.remove();
      observer.disconnect(); // Stop observing once removed
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});







/* ==========================================================================
   Regen cart rules
   - Intro to HBOT: limit to quantity 1
   - 10-Pack HBOT + Red Light: cart drawer note
   ========================================================================== */
document.addEventListener('DOMContentLoaded', function () {
  if (window.__regenCartRulesInit) return;
  window.__regenCartRulesInit = true;

  var INTRO_SKUS = ['IntroToHBOT-60'];
  var TEN_PACK_SKUS = ['hbot-rlt-60', 'hbot-rlt-90'];

  var INTRO_NOTE = 'Limit 1 per customer';
  var TEN_PACK_NOTE = 'Expires one year from date of purchase.\nNo quantity limit.';

  var isWorking = false;

  function isIntroItem(item) {
    if (!item) return false;
    var sku = (item.sku || '').trim();
    var title = (item.product_title || item.title || '').trim();
    return INTRO_SKUS.indexOf(sku) !== -1 || title.indexOf('Intro to HBOT') !== -1;
  }

  function isTenPackItem(item) {
    if (!item) return false;
    var sku = (item.sku || '').trim();
    var title = (item.product_title || item.title || '').trim();
    return TEN_PACK_SKUS.indexOf(sku) !== -1 || title.indexOf('10-Pack') !== -1;
  }

  function fetchCart() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to load cart');
      return res.json();
    });
  }

  function changeLineItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to change cart line');
      return res.json();
    });
  }

  function addVariant(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: quantity }]
      })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed to add variant');
      return res.json();
    });
  }

  function dispatchCartEvents(cart, addedItem) {
    var payload = cart || {};
    if (addedItem) payload.items_added = [addedItem];

    document.dispatchEvent(new CustomEvent('theme:cart:change', {
      detail: { cart: payload }
    }));

    document.dispatchEvent(new CustomEvent('theme:cart:popdown', {
      detail: { cart: payload }
    }));

    document.dispatchEvent(new CustomEvent('cart:updated'));
  }

  function refreshCartDrawerHTML() {
    return fetch('/cart?section_id=cart-drawer', {
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to load cart drawer HTML');
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('#drawer-cart');
        var currentDrawer = document.querySelector('#drawer-cart');

        if (!newDrawer || !currentDrawer) return;

        currentDrawer.innerHTML = newDrawer.innerHTML;
      });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]') || document.getElementById('drawer-cart');
    if (!drawer) return;

    try {
      drawer.dispatchEvent(new CustomEvent('theme:drawer:open', {
        bubbles: false
      }));
    } catch (e) {
      drawer.classList.add('open');
      document.body.classList.add('drawer-open');
    }
  }

  function rowMatchesIntro(row) {
    if (!row) return false;
    var text = (row.textContent || '').trim();
    return text.indexOf('Intro to HBOT') !== -1;
  }

  function rowMatchesTenPack(row) {
    if (!row) return false;
    var text = (row.textContent || '').trim();
    return (
      text.indexOf('10-Pack') !== -1 &&
      (
        text.indexOf('Hyperbaric Oxygen & Red Light') !== -1 ||
        text.indexOf('HBOT') !== -1 ||
        text.indexOf('red light') !== -1 ||
        text.indexOf('Red Light') !== -1
      )
    );
  }

  function getPossibleCartRows() {
    return document.querySelectorAll(
      '#drawer-cart .cart__items__row, ' +
      '#drawer-cart .cart__item, ' +
      '#drawer-cart [data-item], ' +
      '#drawer-cart [data-line-item], ' +
      '.cart__items__row, ' +
      '.cart__item, ' +
      '[data-item], ' +
      '[data-line-item]'
    );
  }

  function disableIntroQuantityUI(row) {
    if (!row) return;

    var qtyWrap =
      row.querySelector('.quantity-selector') ||
      row.querySelector('.quantity__wrapper') ||
      row.querySelector('.quantity') ||
      row.querySelector('[data-quantity-selector]') ||
      row.querySelector('[data-quantity-holder]');

    if (!qtyWrap) return;

    var buttons = qtyWrap.querySelectorAll('button, [data-increase-quantity], [data-decrease-quantity]');
    var input = qtyWrap.querySelector('input');

    buttons.forEach(function (btn) {
      btn.disabled = true;
      btn.style.pointerEvents = 'none';
      btn.style.opacity = '0.45';
      btn.setAttribute('aria-disabled', 'true');
    });

    if (input) {
      input.value = 1;
      input.setAttribute('value', '1');
      input.setAttribute('readonly', 'readonly');
      input.setAttribute('aria-readonly', 'true');
      input.style.pointerEvents = 'none';
      input.style.opacity = '0.7';
    }

    if (!row.querySelector('.cart-item-note--intro-limit')) {
      var note = document.createElement('div');
      note.className = 'cart-item-note--intro-limit';
      note.textContent = INTRO_NOTE;
      note.style.fontSize = '12px';
      note.style.fontStyle = 'italic';
      note.style.lineHeight = '1.35';
      note.style.marginLeft = '1px';
      note.style.display = 'inline-block';
      note.style.verticalAlign = 'middle';

      if (qtyWrap.parentNode) {
        qtyWrap.insertAdjacentElement('afterend', note);
      } else {
        row.appendChild(note);
      }
    }
  }

  function injectTenPackNote(row) {
    if (!row) return;
    if (row.querySelector('.cart-item-note--tenpack')) return;

    var note = document.createElement('div');
    note.className = 'cart-item-note--tenpack';
    note.textContent = TEN_PACK_NOTE;
    note.style.whiteSpace = 'pre-line';
    note.style.marginTop = '8px';
    note.style.fontSize = '13px';
    note.style.lineHeight = '1.4';

    var quantityArea =
      row.querySelector('.quantity-selector') ||
      row.querySelector('.quantity__wrapper') ||
      row.querySelector('.quantity') ||
      row.querySelector('[data-quantity-selector]') ||
      row.querySelector('[data-quantity-holder]');

    if (quantityArea && quantityArea.parentNode) {
      quantityArea.insertAdjacentElement('afterend', note);
    } else {
      row.appendChild(note);
    }
  }

  function enhanceCartUI() {
    var rows = getPossibleCartRows();
    rows.forEach(function (row) {
      if (rowMatchesIntro(row)) disableIntroQuantityUI(row);
      if (rowMatchesTenPack(row)) injectTenPackNote(row);
    });
  }

  function normalizeIntroQuantityIfNeeded() {
    if (isWorking) return Promise.resolve();

    return fetchCart().then(function (cart) {
      var introLines = (cart.items || []).filter(isIntroItem);
      if (!introLines.length) return cart;

      var needsFix = introLines.some(function (item) {
        return item.quantity > 1;
      });

      if (!needsFix) return cart;

      isWorking = true;

      return Promise.all(introLines.map(function (item) {
        return changeLineItem(item.key, 1);
      }))
        .then(function () {
          return fetchCart();
        })
        .then(function (updatedCart) {
          dispatchCartEvents(updatedCart);
          return refreshCartDrawerHTML().then(function () {
            enhanceCartUI();
            return updatedCart;
          });
        })
        .finally(function () {
          isWorking = false;
        });
    }).catch(function (err) {
      console.error('[Regen Cart Rules] normalizeIntroQuantityIfNeeded failed', err);
    });
  }

  function bindIntroProductForms() {
    var forms = document.querySelectorAll('form');

    forms.forEach(function (form) {
      if (form.dataset.introLimitBound === 'true') return;

      var idInput = form.querySelector('input[name="id"]');
      if (!idInput) return;

      form.dataset.introLimitBound = 'true';

      form.addEventListener('submit', function (event) {
        var variantId = idInput.value;
        if (!variantId) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        if (isWorking) return;

        isWorking = true;

        var submitButton = form.querySelector('[type="submit"]');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.setAttribute('aria-busy', 'true');
        }

        fetchCart()
          .then(function (cart) {
            var existingIntro = (cart.items || []).find(isIntroItem);

            if (existingIntro) {
              if (existingIntro.quantity !== 1) {
                return changeLineItem(existingIntro.key, 1).then(function () {
                  return fetchCart();
                });
              }
              return cart;
            }

            return addVariant(variantId, 1)
              .then(function (added) {
                return fetchCart().then(function (updatedCart) {
                  updatedCart.__addedItem = added && added.items ? added.items[0] : added;
                  return updatedCart;
                });
              });
          })
          .then(function (cart) {
            var addedItem = cart.__addedItem || null;
            dispatchCartEvents(cart, addedItem);

            return refreshCartDrawerHTML().then(function () {
              enhanceCartUI();
              openCartDrawer();
            });
          })
          .catch(function (err) {
            console.error('[Regen Cart Rules] Intro to HBOT add failed', err);
            window.location.href = '/cart';
          })
          .finally(function () {
            isWorking = false;
            if (submitButton) {
              submitButton.disabled = false;
              submitButton.setAttribute('aria-busy', 'false');
            }
          });
      }, true);
    });
  }

  function observeCartChanges() {
    var drawer = document.getElementById('drawer-cart');
    var target = drawer || document.body;

    var observer = new MutationObserver(function () {
      enhanceCartUI();
    });

    observer.observe(target, {
      childList: true,
      subtree: true
    });
  }

  bindIntroProductForms();
  enhanceCartUI();
  observeCartChanges();

  document.addEventListener('theme:cart:change', function () {
    enhanceCartUI();
    normalizeIntroQuantityIfNeeded();
  });

  document.addEventListener('cart:updated', function () {
    enhanceCartUI();
    normalizeIntroQuantityIfNeeded();
  });

  document.addEventListener('shopify:section:load', function () {
    bindIntroProductForms();
    enhanceCartUI();
    normalizeIntroQuantityIfNeeded();
  });

  document.addEventListener('shopify:section:reorder', function () {
    bindIntroProductForms();
    enhanceCartUI();
    normalizeIntroQuantityIfNeeded();
  });

  setTimeout(function () {
    normalizeIntroQuantityIfNeeded();
    enhanceCartUI();
  }, 300);
  
});







/*
 * REGEN RECOVERY
 * BLACK FRIDAY 2026 - GLOBAL CART SAFETY
 *
 * Add to the very bottom of assets/custom.js.
 *
 * Ensures the promotional HBOT session does not
 * remain in the cart incorrectly after customers
 * navigate away from the Black Friday landing page.
 *
 * Also identifies the Pipeline cart drawer's
 * correct scrolling container.
 */

(function () {
  'use strict';

  if (window.__regenBF26GlobalCartSafety) return;
  window.__regenBF26GlobalCartSafety = true;

  var timer;
  var running = false;

  var root = (
    window.Shopify &&
    window.Shopify.routes &&
    window.Shopify.routes.root
  ) || '/';

  // Eligible Black Friday bundle SKUs

  var eligible = {
    'BF_Recovery_Essentials': true,
    'BF_Scan&Sauna': true
  };


  // ==========================================
  // IDENTIFY THE CART DRAWER SCROLL CONTAINER
  // ==========================================

  function fixScrollTarget() {

    var drawer = document.querySelector(
      '[data-drawer="drawer-cart"]'
    );

    if (!drawer) return;

    var inner = drawer.querySelector('.drawer__inner');
    var body = drawer.querySelector('.drawer__body');

    var scroll = drawer.querySelector(
      '[data-drawer-scrolls]'
    );

    drawer.classList.toggle(
      'bf26-scroll-body',
      Boolean(
        scroll &&
        inner &&
        body &&
        scroll !== inner &&
        (
          scroll === body ||
          body.contains(scroll)
        )
      )
    );

  }


  // ==========================================
  // VALIDATE THE FREE HBOT CART ITEM
  // ==========================================

  async function protectGift() {

    // The Black Friday landing page already
    // manages the promotion while it is open.

    if (document.getElementById('regen-bf26')) {
      return;
    }

    if (running) return;

    running = true;

    try {

      var response = await fetch(
        root + 'cart.js',
        {
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json'
          }
        }
      );

      if (!response.ok) return;

      var cart = await response.json();


      // Count eligible bundle quantities.

      var count = (cart.items || []).reduce(
        function (total, item) {

          var sku = (item.sku || '').trim();

          return total + (
            eligible[sku]
              ? Number(item.quantity) || 0
              : 0
          );

        },
        0
      );


      // Find promotional HBOT-60 cart items.

      var bonuses = (cart.items || []).filter(
        function (item) {

          return (
            item.properties &&
            item.properties._BF26_HBOT_Bonus === 'Yes' &&
            (item.sku || '').trim() === 'HBOT-60'
          );

        }
      );


      if (!bonuses.length) return;


      // A valid promotion requires:
      // - At least 2 qualifying bundles
      // - Exactly 1 promotional HBOT session
      // - A final HBOT price of $0

      if (
        count >= 2 &&
        bonuses.length === 1 &&
        bonuses[0].quantity === 1 &&
        Number(bonuses[0].final_line_price) === 0
      ) {
        return;
      }


      // Remove invalid or excess bonus items.

      for (var i = 0; i < bonuses.length; i++) {

        var line = bonuses[i];

        var quantity = (
          count >= 2 &&
          i === 0 &&
          Number(line.final_line_price) === 0
        ) ? 1 : 0;

        var result = await fetch(
          root + 'cart/change.js',
          {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
              'Content-Type': 'application/json',
              Accept: 'application/json'
            },
            body: JSON.stringify({
              id: line.key,
              quantity: quantity
            })
          }
        );

        if (!result.ok) {
          throw new Error(
            'Unable to reconcile free HBOT'
          );
        }

      }


      // Refresh the Shopify cart drawer.

      document.dispatchEvent(
        new CustomEvent(
          'theme:cart:reload',
          { bubbles: true }
        )
      );


      var updated = await fetch(
        root + 'cart.js',
        { credentials: 'same-origin' }
      ).then(function (response) {
        return response.json();
      });


      document.dispatchEvent(
        new CustomEvent(
          'theme:cart:change',
          {
            detail: {
              cart: updated,
              bf26Internal: true
            },
            bubbles: true
          }
        )
      );


    } catch (error) {

      console.error(
        'Regen Black Friday cart safety:',
        error
      );

    } finally {

      running = false;

    }

  }


  // ==========================================
  // DEBOUNCE CART CHECKS
  // ==========================================

  function schedule() {

    fixScrollTarget();

    clearTimeout(timer);

    timer = setTimeout(
      protectGift,
      280
    );

  }


  // ==========================================
  // SHOPIFY CART EVENT LISTENERS
  // ==========================================

  document.addEventListener(
    'theme:cart:change',
    function (event) {

      if (
        event.detail &&
        event.detail.bf26Internal
      ) {
        return;
      }

      schedule();

    }
  );


  document.addEventListener(
    'theme:cart:reload',
    schedule
  );


  // ==========================================
  // INITIALIZATION
  // ==========================================

  function start() {

    fixScrollTarget();
    protectGift();

    var drawer = document.querySelector(
      '[data-drawer="drawer-cart"]'
    );

    if (drawer) {

      drawer.addEventListener(
        'theme:drawer:open',
        schedule
      );

      new MutationObserver(
        fixScrollTarget
      ).observe(
        drawer,
        {
          childList: true,
          subtree: true
        }
      );

    }

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );

  } else {

    start();

  }

})();

/* ========================================================================== */